// extracted by mini-css-extract-plugin
export default {"table":"AiTable_table__C3F8e"};